import React, { useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import RemotePodLoader from "../components/recording/RemotePodLoader";

const loadRecordingSpirometry = () => import("recordingSpirometry/App");

export default function RecordingSpirometryRouter(props) {
  const navigate = useNavigate();
  const didRedirectRef = useRef(false);

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // Optional: route away from /recording/spirometry/camera once upload begins
      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate("/recording/spirometry", { replace: true });
      }
    },
    [navigate, props]
  );

  return (
    <RemotePodLoader
      load={loadRecordingSpirometry}
      componentProps={{
        ...props,
        onUploadStatus: handleUploadStatus,
        onUploadProgress: props.onUploadProgress,
      }}
    />
  );
}
